import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

import { DropdownItem } from '@treezor/design-system';

import { useAccesControl } from '@/hooks/useAccessControl';
import { useAppDispatch } from '@/hooks/redux-helpers';

import { openModal } from '@/store/actions/core.actions';

import { IUser } from '@/features/user/store/user.model';

import { featuresSlugs } from '@/features/roles/store/models/features.model';
import { useMatomo } from '@/features/matomo/useMatomo';

import { IP2PTransferModalProps } from './P2PTransferModal';

interface IP2PProps {
  user: IUser;
}

export const P2PTransfer = ({ user }: IP2PProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { hasAccessToFeature } = useAccesControl();
  const { triggerEvent } = useMatomo();

  const toggleP2PTransferProcessModal = useCallback(() => {
    triggerEvent('p2p', { 'p2p-action': 'start' });
    dispatch(openModal<IP2PTransferModalProps>('p2pTransferModal', { user }, { maxWidth: 'lg' }));
  }, [triggerEvent, dispatch, user]);

  if (!hasAccessToFeature(featuresSlugs.WALLET_TO_WALLET_TRANSFER)) {
    return null;
  }

  return (
    <DropdownItem
      onClick={toggleP2PTransferProcessModal}
      label={t('pages.currentProfiles.wallets.actions.p2pTransfer')}
      testId="p2p-transfer"
    />
  );
};

export default P2PTransfer;
